import { axiosApiInstancePrivate } from '../index';
import axios, { AxiosError } from 'axios';

export const action = async (
  hash: string
): Promise<{
  redirect?: string; hash: string 
}> => {
  try {
    const response = await axiosApiInstancePrivate.get<{
      hash: string;
    }>(`/v1/al/bo/${hash}`);

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};